import { Button } from 'react-bootstrap';
import Tippy from '@tippyjs/react';

export type TableControlsProps = {
  getTable: () => HTMLDivElement | null;
};

const TableControls = ({ getTable }: TableControlsProps): JSX.Element => {
  const scrollToBottom = (event): void => {
    event.preventDefault();
    event.stopPropagation();
    const table = getTable();
    if (!table) return;
    const lastRow = table.querySelector('.Table-End');
    if (lastRow) {
      lastRow.scrollIntoView({ behavior: 'instant', block: 'end' });
    }
  };
  const scrollToTop = (event): void => {
    event.preventDefault();
    event.stopPropagation();
    const table = getTable();
    if (!table) return;
    const firstRow = table.querySelector('.Table-Start');
    if (firstRow) {
      firstRow.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  };

  return (
    <div className="Table-Controls">
      <Tippy className="tippy-dark" content="Scroll to bottom" placement="left">
        <Button className="Table-ScrollDown" variant="secondary-subtle" onClick={scrollToBottom}>
          <i className="fa fa-chevron-down" />
        </Button>
      </Tippy>
      <div className="Table-Addons" />
      <Tippy className="tippy-dark" content="Scroll to top" placement="left">
        <Button className="Table-ScrollUp" variant="secondary-subtle" onClick={scrollToTop}>
          <i className="fa fa-chevron-up" />
        </Button>
      </Tippy>
    </div>
  );
};

export default TableControls;
